import "./AboutUs.css";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useRef } from "react";
const AboutUs = () => {
  const about_ref = useRef(null);
  return (
    <>
      <Container
        ref={about_ref}
        fluid
        className="p-0 m-0 about_us_parent"
        id="about"
      >
        <Container className="about_us_root">
          <Row className="about_us_wrapper">
            <Col lg={6}>
              <div className="about_us_left">
                <h2 className="about_us_title">About us</h2>
                <div className="about_us_descrip">
                  <p>
                    Established in 2012 as Pradeep Automotive Pvt Ltd (PAPL) and
                    formerly known as Pradeep Automobiles, we have more than
                    three decades of experience in delivering excellence in the
                    Indian aftermarket industry. As a family-owned business with
                    its headquarters in Mumbai, we have extensive operations
                    across Maharashtra, Madhya Pradesh, and Chhattisgarh.
                  </p>
                  <p style={{ marginTop: "30px" }}>
                    Our commitment is to provide reliable brand products and
                    consistent service at a highly competitive price. Our
                    portfolio of commercial vehicle products includes OEM
                    products for leading brands such as Tata, Ashok Leyland,
                    DAIMLER Bharat Benz, Mahindra & Mahindra, MAN, AMW, and
                    Volvo Eicher. We also cater to PCV/UV/LCV with products for
                    Maruti, Hyundai, M&M, TML, Honda, Skoda, VW, and more.
                  </p>
                  <p style={{ marginTop: "30px" }}>
                    Our trained support team works closely with customers to
                    ensure they select the right product and provide technical
                    support as needed. We understand the importance of technical
                    expertise and strive to deliver high-quality products and
                    services that meet our customers' requirements.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="about_us_right">
                <div className="about_us_right_content">
                  <img
                    className="orange_pattern_1"
                    src="assets/images/orange_pattern.png"
                    alt="orange_pattern"
                  ></img>
                  <img
                    className="orange_pattern_2"
                    src="assets/images/orange_pattern.png"
                    alt="orange_pattern"
                  ></img>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};
export default AboutUs;
